<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ScheduleMenuBar from '../../../../../schedule/components/ScheduleMenuBar.vue'

definePage({
    meta: {
        requiresAuth: true,
        requiresOrganisation: true,
        useFullContainer: true,
        hideLeftColumn: true,
        hideRightColumn: true,
    }
})
</script>

<template>
  <ScheduleMenuBar />
</template>